"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDay = void 0;
var CalendarDay_base_1 = require("./CalendarDay.base");
var CalendarDay_styles_1 = require("./CalendarDay.styles");
var Utilities_1 = require("../../../Utilities");
exports.CalendarDay = Utilities_1.styled(CalendarDay_base_1.CalendarDayBase, CalendarDay_styles_1.styles, undefined, {
    scope: 'CalendarDay',
});
//# sourceMappingURL=CalendarDay.js.map